import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import './LearnPageHeader.css';

export function LearnPageHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  // Determine active section based on current path
  const getActiveSection = () => {
    const path = location.pathname;
    if (path.includes('/admin')) return 'admin';
    if (path.includes('/tutorial-videos')) return 'tutorial-videos';
    if (path.includes('/questions-answers')) return 'questions-answers';
    if (path.includes('/trivia')) return 'trivia';
    return 'main';
  };

  const activeSection = getActiveSection();

  const handleNavigation = (section) => {
    if (section === 'main') {
      navigate('/learn');
    } else {
      navigate(`/learn/${section}`);
    }
  };

  return (
    <div className="learn-page-header">
      <div className="learn-page-header-content">
        {/* Left side - Learn button (styled like Revolt button) */}
        <div className="learn-page-header-left">
          <a
            href="/learn"
            className={`learn-logo-container ${activeSection === 'main' ? 'active' : ''}`}
            onClick={(e) => {
              e.preventDefault();
              handleNavigation('main');
            }}
          >
            <img
              src="https://bluedrake42.nyc3.cdn.digitaloceanspaces.com/revolt-site/site-assets/logo/revolt-learn-logo-small-transparent.png"
              alt="Revolt"
              className="learn-logo-img"
            />
            <span className="learn-logo-text">Learn</span>
          </a>
        </div>

        {/* Right side - Navigation buttons (styled like main header) */}
        <nav className="learn-page-header-nav">
          <a
            href="/learn/tutorial-videos"
            className={`header-nav-item ${activeSection === 'tutorial-videos' ? 'active' : ''}`}
            onClick={(e) => {
              e.preventDefault();
              handleNavigation('tutorial-videos');
            }}
          >
            Tutorial Videos
          </a>

          <a
            href="/learn/questions-answers"
            className={`header-nav-item ${activeSection === 'questions-answers' ? 'active' : ''}`}
            onClick={(e) => {
              e.preventDefault();
              handleNavigation('questions-answers');
            }}
          >
            Questions & Answers
          </a>

          <a
            href="/learn/trivia"
            className={`header-nav-item ${activeSection === 'trivia' ? 'active' : ''}`}
            onClick={(e) => {
              e.preventDefault();
              handleNavigation('trivia');
            }}
          >
            Trivia
          </a>

          {/* Admin button - only visible to admins */}
          {user?.role === 'admin' && (
            <a
              href="/learn/admin"
              className={`admin-nav-item ${activeSection === 'admin' ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                // Map current section to corresponding admin tab
                const adminTabMap = {
                  'main': 'home',
                  'tutorial-videos': 'tutorial-videos',
                  'questions-answers': 'questions-answers',
                  'trivia': 'trivia'
                };
                const targetTab = adminTabMap[activeSection] || 'home';
                navigate(`/learn/admin?tab=${targetTab}`);
              }}
            >
              <i className="fa-solid fa-cog"></i>
              Admin
            </a>
          )}
        </nav>
      </div>
    </div>
  );
}